<template>
  <div class="flow-details settings-wrapper">
    <div class="subtitle">
      {{ t('Flow settings') }}
    </div>
    <div class="p-16 flow-details__wrap flow-details__settings">
      <div class="flow-details__settings-fields">
        <div>
          <workspace-select
            :form="form"
            @change-workspace="emit('change-workspace', $event)"
            :label-help-text="t('Workspace allows to make the required flow or other element accessible only by a specific member or group of members')"
            :disabled="disabledWorkspace"
            :workspaces-list="workspacesList"
          ></workspace-select>
        </div>
        <div>
          <ui-input
            v-model="form.name"
            :placeholder="t('Name')"
            :label="t('Name') + '*'"
            name="name"
            :hide-details="1"
            :error-messages="errorsDict['name']"
          ></ui-input>
        </div>

        <div class="input-tip pl-16 pb-16">
          {{ nameDescription }}
        </div>

        <div>
          <ui-select
            v-model="form.countryId"
            :placeholder="t('Global')"
            :label="t('Country')"
            :items="countryListPlusGlobal"
            @change="emit('change-country', $event)"
            item-text="name"
            item-value="id"
            :return-object="false"
            :hide-details="2"
            attach
            :error-messages="errorsDict['countryId']"
          ></ui-select>
        </div>

        <div :class="{'plan-limits-warning__tags': showPlanLimitsWarningTags}">
          <ui-select
            plan-limits="tagsFlows"
            v-model="form.tags"
            :placeholder="t('Select or type tags...')"
            :label="t('Tags')"
            :items="store.cache.tags.flows.data"
            item-text="name"
            :hide-details="2"
            multiple
            chips
            attach
            combobox
            multi-line
            :error-messages="errorsDict['tags']"
          >
            <template #no-data>
              <no-tag-found></no-tag-found>
            </template>
          </ui-select>
          <button v-if="showPlanLimitsWarningTags" class="plan-limits-warning__clear" @click="clearTags">
            {{ t('Reset tags') }}
          </button>
          <ui-tooltip-icon
            class="plan-limits-warning__tooltip"
            preset="error"
            v-if="showPlanLimitsWarningTags"
            :text="t('This option is no longer active due to the subscription change to the plan which doesn’t include this option or this add-on is switched off in your subscriptions settings.')"
          ></ui-tooltip-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import WorkspaceSelect from '@/views/reports/pickers/wokrspace-select.vue';
import NoTagFound from '@/views/reports/views/no-tag-found.vue';
import { useFlowSettings } from './useFlowSettings';

const props = defineProps<{
  form: {
    name?: string;
    countryId?: number;
    tags?: unknown[];
    workspaceId?: string;
  };
  disabledWorkspace?: boolean;
  workspacesList: unknown;
  errorsDict?: Record<string, string[]>;
}>();

const emit = defineEmits<{
  'change-workspace': [value: unknown];
  'change-country': [value: unknown];
}>();

const {
  t,
  store,
  countryListPlusGlobal,
  nameDescription,
  showPlanLimitsWarningTags,
  clearTags,
} = useFlowSettings(props);
</script>

<style lang="scss" scoped>
@import '@/styles/dialogs/report-modals';
</style>

<style lang="scss">
.flow-details {
  overflow: auto;

  &__settings-fields {
    // Former grid column xs6
    width: 50%;
    max-width: 50%;
  }

  &__tags {
    &.v-select--chips.v-text-field .v-input__append-inner {
      top: 25px !important;
    }
  }
}
</style>
